import { FC } from 'react';

import image from './svg/image.svg';
import link from './svg/link.svg';
import pdf from './svg/pdf.svg';

const icons = {
  link,
  pdf,
  image,
};

export type IconName = keyof typeof icons;

interface IconProps {
  name: IconName;
  size?: number;
}

const Icon: FC<IconProps> = ({ name, size }: IconProps) => {
  const icon = icons[name];

  return <img data-testid={name} className="icon" src={icon} width={size} />;
};

Icon.defaultProps = {
  size: 18,
};

export default Icon;
